// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { online } from '../Assets/index'; // Assuming this is an image for rewards
// import baseUrl from '../config';

// // Heroicons imports (make sure you have @heroicons/react installed)
// import {
//     StarIcon,
//     LockClosedIcon,
//     ChartBarIcon,
//     GiftIcon,
//     TrophyIcon,
//     XMarkIcon,
//     SparklesIcon,
//     CurrencyDollarIcon,
//     GlobeAltIcon, // For country
//     DevicePhoneMobileIcon, // For phone
//     AtSymbolIcon, // For email
//     MapPinIcon, // For address
//     UserIcon // For name
// } from '@heroicons/react/24/outline';

// const Reward = () => {
//     const [dashboardData, setDashboardData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [redeeming, setRedeeming] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [addressLine1, setAddressLine1] = useState('');
//     const [addressLine2, setAddressLine2] = useState('');
//     const [city, setCity] = useState('');
//     const [state, setState] = useState('');
//     const [postalCode, setPostalCode] = useState('');
//     const [country, setCountry] = useState('India');
//     const [phoneNumber, setPhoneNumber] = useState('');
//     const [email, setEmail] = useState('');
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: '',
//         type: 'success'
//     });
//     const token = localStorage.getItem('token');

//     // Fetch dashboard data
//     useEffect(() => {
//         const fetchDashboardData = async () => {
//             try {
//                 const response = await axios.get(baseUrl + 'api/students/wallet/getwallet', {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 });
//                 setDashboardData(response.data);
//                 setEmail(response.data.user?.email || '');
//                 setLoading(false);
//             } catch (err) {
//                 setError(err.response?.data?.message || 'Failed to fetch dashboard data');
//                 setLoading(false);
//                 console.error(err);
//             }
//         };

//         fetchDashboardData();
//     }, [token, baseUrl]);

//     // Handle product redemption
//     const handleRedeemClick = (product) => {
//         setSelectedProduct(product);
//     };

//     const handleCloseDialog = () => {
//         setSelectedProduct(null);
//         setAddressLine1('');
//         setAddressLine2('');
//         setCity('');
//         setState('');
//         setPostalCode('');
//         setCountry('India');
//         setPhoneNumber('');
//     };

//     const handleRedeemSubmit = async () => {
//         setRedeeming(true);
//         try {
//             await axios.post(baseUrl + 'api/rewards/redeem', {
//                 productId: selectedProduct._id,
//                 studentsDetails: {
//                     fullName: dashboardData?.userName,
//                     addressLine1,
//                     addressLine2,
//                     city,
//                     state,
//                     postalCode,
//                     country,
//                     phoneNumber,
//                     email
//                 }
//             }, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             });

//             // Refresh dashboard data
//             const response = await axios.get(baseUrl + 'api/students/wallet/getwallet', {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             });
//             setDashboardData(response.data);

//             setSnackbar({
//                 open: true,
//                 message: 'Redemption request submitted for admin approval!',
//                 type: 'success'
//             });
//             handleCloseDialog();
//         } catch (err) {
//             setSnackbar({
//                 open: true,
//                 message: err.response?.data?.message || 'Redemption failed',
//                 type: 'error'
//             });
//         } finally {
//             setRedeeming(false);
//         }
//     };

//     const handleCloseSnackbar = () => {
//         setSnackbar({ ...snackbar, open: false });
//     };

//     // Determine reward status based on points
//     const getRewardStatus = (pointsRequired) => {
//         if (!dashboardData) return 'locked';

//         const userPoints = dashboardData.balance || 0;

//         return userPoints >= pointsRequired ? 'available' : 'locked';
//     };

//     // Default rewards data (using online as a placeholder image)
//     const defaultRewards = [
//         { _id: '1', name: 'Shoutout on Oratrics Page', pointsRequired: 150, image: online },
//         { _id: '2', name: 'Custom Oratrics Badge', pointsRequired: 200, image: online },
//         { _id: '3', name: 'Get 5 extra classes', pointsRequired: 250, image: online },
//         { _id: '4', name: 'Get 5 Maths classes', pointsRequired: 350, image: online },
//         { _id: '5', name: 'Amazon gift card ($50)', pointsRequired: 500, image: online },
//         { _id: '6', name: 'Oratrics Goodie Bag', pointsRequired: 600, image: online },
//         { _id: '7', name: 'RGB Desk Lamp', pointsRequired: 750, image: online },
//         { _id: '8', name: 'Amazon Echo Dot', pointsRequired: 1000, image: online },
//         { _id: '9', name: 'Amazon Kindle', pointsRequired: 1500, image: online },
//         { _id: '10', name: 'Apple AirPods Pro', pointsRequired: 3000, image: online },
//         { _id: '11', name: 'Sony PS5', pointsRequired: 4500, image: online },
//         { _id: '12', name: 'Apple MacBook Air', pointsRequired: 10000, image: online },
//     ];

//     // Earn points actions
//     const earnActions = [
//         { text: 'Complete a course module', points: 10 },
//         { text: 'Win a weekly speech challenge', points: 20 },
//         { text: 'Share a speech on Social Media with #oratrics', points: 50 },
//         { text: 'Get a friend to attend a free trial class', points: 100 },
//     ];

//     if (loading) {
//         return (
//             <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-100 to-purple-100 font-sans">
//                 <div className="flex flex-col items-center p-6 bg-white rounded-3xl shadow-xl animate-bounce-slow">
//                     <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-blue-500 mb-6"></div>
//                     <p className="text-blue-700 text-2xl font-bold animate-pulse">Gathering your treasures...</p>
//                 </div>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-red-100 to-orange-100 font-sans">
//                 <div className="bg-red-200 border-4 border-red-500 text-red-800 px-8 py-6 rounded-3xl shadow-lg text-center animate-shake">
//                     <p className="text-3xl font-extrabold mb-3">Oopsie!</p>
//                     <p className="text-xl font-medium">{error}</p>
//                     <p className="text-md mt-2">Looks like something went wrong. Try again later!</p>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="p-6 sm:p-8 md:p-10 bg-gradient-to-br from-blue-100 via-purple-100 to-pink-100 min-h-screen font-sans relative overflow-hidden">
//             {/* Background elements for fun */}
//             <div className="absolute top-10 left-10 w-24 h-24 bg-yellow-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
//             <div className="absolute bottom-20 right-20 w-32 h-32 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
//             <div className="absolute top-1/2 left-1/4 w-28 h-28 bg-green-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>

//             <div className="relative z-10"> {/* Ensure content is above background elements */}


//                 {/* Rewards Overview Section */}
//                <div className="bg-white rounded-3xl shadow-2xl p-4 sm:p-6 mb-8 border-4 border-blue-200 transform transition duration-500 hover:scale-[1.01] hover:shadow-3xl">
//   <div className="flex items-center text-blue-700 mb-4">
//     <TrophyIcon className="h-8 w-8 mr-3 text-yellow-500 drop-shadow-md animate-spin-slow" />
//     <h2 className="text-2xl font-bold text-gray-800">Your Treasure Chest</h2>
//   </div>

//   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//     <div className="flex flex-col items-center justify-center p-4 bg-gradient-to-br from-yellow-300 to-orange-400 rounded-2xl shadow-lg border-4 border-yellow-500 animate-pop-in">
//       <CurrencyDollarIcon className="h-14 w-14 text-white mb-3 animate-bounce-icon drop-shadow-md" />
//       <p className="text-white text-lg font-semibold mb-1">Your Shiny Points</p>
//       <p className="text-white font-extrabold text-6xl leading-tight drop-shadow-lg">
//         {dashboardData?.balance || 0}
//       </p>
//       <p className="text-white text-sm mt-2 font-medium">Keep earning, you're doing great!</p>
//     </div>

//                         {/* How to Earn Points Section */}
//                         <div className="bg-white p-8 rounded-2xl shadow-lg border-4 border-green-200 animate-pop-in animation-delay-200">
//                             <div className="flex items-center text-gray-800 mb-6">
//                                 <ChartBarIcon className="h-9 w-9 mr-4 text-green-600 drop-shadow-md" />
//                                 <h3 className="text-2xl font-bold">Quests to Earn More Points!</h3>
//                             </div>
//                             <ul className="space-y-5">
//                                 {earnActions.map((item, index) => (
//                                     <li key={index} className="flex items-center bg-green-50 p-4 rounded-xl border border-green-200 transition duration-300 ease-in-out transform hover:scale-[1.02] hover:shadow-md cursor-pointer">
//                                         <span className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-green-300 text-green-800 rounded-full font-extrabold text-lg mr-4 shadow-sm animate-bubble">
//                                             +{item.points}
//                                         </span>
//                                         <p className="text-lg text-gray-700 flex-grow font-medium">
//                                             {item.text}
//                                         </p>
//                                         <button
//                                             className="text-blue-500 hover:text-blue-700 font-bold text-sm flex items-center transition-colors duration-200 transform hover:scale-110"
//                                             onClick={() => setSnackbar({ open: true, message: `Awesome! Go on a quest to "${item.text}"!`, type: 'info' })}
//                                         >
//                                             Start Quest <SparklesIcon className="h-5 w-5 ml-2 text-yellow-400" />
//                                         </button>
//                                     </li>
//                                 ))}
//                             </ul>
//                             <button
//                                 className="w-full mt-8 bg-blue-100 text-blue-700 font-bold py-4 rounded-xl border-2 border-blue-300 hover:bg-blue-200 transition-colors duration-200 shadow-md transform hover:scale-105"
//                             >
//                                 See All Adventures
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Available Rewards Section */}
//                 <div className="flex items-center text-gray-900 mb-8 mt-16">
//                     <GiftIcon className="h-10 w-10 mr-4 text-purple-600 drop-shadow-md" />
//                     <h2 className="text-3xl font-bold">Unbox Your Awesome Rewards!</h2>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
//                     {defaultRewards.map((reward) => {
//                         const status = getRewardStatus(reward.pointsRequired);
//                         const progress = Math.min(100, ((dashboardData?.balance || 0) / reward.pointsRequired) * 100);

//                         return (
//                             <div
//                                 key={reward._id}
//                                 className={`bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col transform transition-all duration-300 ease-in-out ${status === 'locked' ? 'opacity-80 border-4 border-gray-200' : 'border-4 border-blue-300 hover:scale-[1.04] hover:shadow-2xl'}`}
//                             >
//                                 <div className="relative w-full h-56 overflow-hidden bg-gray-100 flex items-center justify-center">
//                                     <img
//                                         src={reward.image}
//                                         alt={reward.name}
//                                         className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//                                     />
//                                     {status === 'locked' && (
//                                         <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center p-4">
//                                             <LockClosedIcon className="h-16 w-16 text-yellow-300 animate-bounce-slow" />
//                                             <p className="text-white text-xl font-bold mt-2 text-center drop-shadow-lg">Locked!</p>
//                                         </div>
//                                     )}
//                                 </div>
//                                 <div className="p-6 flex flex-col flex-grow">
//                                     <div className="mb-4">
//                                         <span className={`inline-flex items-center px-4 py-1.5 rounded-full text-sm font-semibold ${status === 'locked' ? 'bg-gray-200 text-gray-700' : 'bg-green-100 text-green-800'}`}>
//                                             {status === 'locked' ? (
//                                                 <>
//                                                     <LockClosedIcon className="h-4 w-4 mr-2" /> Locked Prize
//                                                 </>
//                                             ) : (
//                                                 'Ready to Claim!'
//                                             )}
//                                         </span>
//                                     </div>
//                                     <h3 className="text-2xl font-bold text-gray-800 mb-4 leading-tight">
//                                         {reward.name}
//                                     </h3>
//                                     <div className="w-full bg-blue-200 rounded-full h-3 mb-3">
//                                         <div
//                                             className="bg-gradient-to-r from-yellow-400 to-orange-500 h-full rounded-full animate-progress"
//                                             style={{ width: `${progress}%` }}
//                                         ></div>
//                                     </div>
//                                     <div className="flex justify-between items-center text-md text-gray-600 mb-5 font-medium">
//                                         <span className="font-bold text-purple-600">{dashboardData?.balance || 0} / {reward.pointsRequired} Points</span>
//                                         <span className="text-orange-500 font-bold">{reward.pointsRequired - (dashboardData?.balance || 0)} more points!</span>
//                                     </div>
//                                     <button
//                                         className={`w-full py-4 rounded-xl font-extrabold text-lg text-white transition-all duration-300 ease-in-out shadow-lg transform hover:scale-105
//                                             ${status === 'locked' ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 active:from-blue-700 active:to-blue-900'}
//                                         `}
//                                         onClick={() => handleRedeemClick(reward)}
//                                         disabled={status === 'locked'}
//                                     >
//                                         {status === 'locked' ? 'Keep Earning!' : 'Redeem My Prize!'}
//                                     </button>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>

//                 {/* Redemption Dialog */}
//                 {selectedProduct && (
//                     <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center p-4 z-50 animate-fade-in backdrop-blur-sm">
//                         <div className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl transform scale-95 animate-scale-up border-4 border-purple-300 relative">
//                             <div className="p-8 border-b-4 border-gray-100 flex justify-between items-center bg-gradient-to-r from-blue-500 to-purple-500 rounded-t-2xl">
//                                 <h2 className="text-3xl font-extrabold text-white">Claim Your <span className="text-yellow-300">{selectedProduct.name}</span>!</h2>
//                                 <button onClick={handleCloseDialog} className="text-white hover:text-gray-100 p-2 rounded-full hover:bg-blue-600 transition-colors transform hover:scale-110">
//                                     <XMarkIcon className="h-8 w-8" />
//                                 </button>
//                             </div>
//                             <div className="p-8 overflow-y-auto max-h-[70vh]">
//                                 <h3 className="text-2xl font-bold text-gray-800 mb-6">
//                                     Tell us where to send your prize!
//                                 </h3>
//                                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6 mb-8">
//                                     {/* Input fields with modern floating labels and icons */}
//                                     <div className="relative z-0 w-full group">
//                                         <input
//                                             type="text"
//                                             id="fullName"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={dashboardData?.userName || ''}
//                                             disabled
//                                         />
//                                         <label htmlFor="fullName" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             <UserIcon className="inline-block h-6 w-6 mr-2 text-gray-400" /> Your Full Name
//                                         </label>
//                                     </div>
//                                     <div className="relative z-0 w-full group">
//                                         <input
//                                             type="email"
//                                             id="email"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={email}
//                                             onChange={(e) => setEmail(e.target.value)}
//                                             required
//                                         />
//                                         <label htmlFor="email" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             <AtSymbolIcon className="inline-block h-6 w-6 mr-2 text-gray-400" /> Your Email Address
//                                         </label>
//                                     </div>
//                                     <div className="relative z-0 w-full group col-span-full">
//                                         <input
//                                             type="text"
//                                             id="addressLine1"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={addressLine1}
//                                             onChange={(e) => setAddressLine1(e.target.value)}
//                                             required
//                                         />
//                                         <label htmlFor="addressLine1" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             <MapPinIcon className="inline-block h-6 w-6 mr-2 text-gray-400" /> Street Address Line 1
//                                         </label>
//                                     </div>
//                                     <div className="relative z-0 w-full group col-span-full">
//                                         <input
//                                             type="text"
//                                             id="addressLine2"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={addressLine2}
//                                             onChange={(e) => setAddressLine2(e.target.value)}
//                                         />
//                                         <label htmlFor="addressLine2" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             <MapPinIcon className="inline-block h-6 w-6 mr-2 text-gray-400" /> Apartment, Suite, etc. (Optional)
//                                         </label>
//                                     </div>
//                                     <div className="relative z-0 w-full group">
//                                         <input
//                                             type="text"
//                                             id="city"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={city}
//                                             onChange={(e) => setCity(e.target.value)}
//                                             required
//                                         />
//                                         <label htmlFor="city" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             City
//                                         </label>
//                                     </div>
//                                     <div className="relative z-0 w-full group">
//                                         <input
//                                             type="text"
//                                             id="state"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={state}
//                                             onChange={(e) => setState(e.target.value)}
//                                             required
//                                         />
//                                         <label htmlFor="state" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             State/Province
//                                         </label>
//                                     </div>
//                                     <div className="relative z-0 w-full group">
//                                         <input
//                                             type="text"
//                                             id="postalCode"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={postalCode}
//                                             onChange={(e) => setPostalCode(e.target.value)}
//                                             required
//                                         />
//                                         <label htmlFor="postalCode" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             Postal Code
//                                         </label>
//                                     </div>
//                                     <div className="relative z-0 w-full group">
//                                         <input
//                                             type="text"
//                                             id="country"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={country}
//                                             onChange={(e) => setCountry(e.target.value)}
//                                             required
//                                         />
//                                         <label htmlFor="country" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             <GlobeAltIcon className="inline-block h-6 w-6 mr-2 text-gray-400" /> Country
//                                         </label>
//                                     </div>
//                                     <div className="relative z-0 w-full group">
//                                         <input
//                                             type="text"
//                                             id="phoneNumber"
//                                             className="block py-3 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-colors"
//                                             placeholder=" "
//                                             value={phoneNumber}
//                                             onChange={(e) => setPhoneNumber(e.target.value)}
//                                             required
//                                         />
//                                         <label htmlFor="phoneNumber" className="absolute text-gray-500 text-lg duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:start-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
//                                             <DevicePhoneMobileIcon className="inline-block h-6 w-6 mr-2 text-gray-400" /> Phone Number
//                                         </label>
//                                     </div>
//                                 </div>
//                                 <div className="bg-blue-50 p-6 rounded-2xl border-4 border-blue-200 shadow-inner mt-8">
//                                     <h3 className="text-2xl font-bold text-blue-700 mb-4">Your Prize Details</h3>
//                                     <div className="flex justify-between items-center text-gray-700 text-lg mb-2">
//                                         <span>Prize Name:</span>
//                                         <span className="font-bold text-gray-900">{selectedProduct?.name}</span>
//                                     </div>
//                                     <div className="flex justify-between items-center text-gray-700 text-lg mb-2">
//                                         <span>Points Needed:</span>
//                                         <span className="font-bold text-orange-600">{selectedProduct?.pointsRequired}</span>
//                                     </div>
//                                     <div className="flex justify-between items-center text-gray-700 font-extrabold text-xl border-t-2 pt-4 mt-4 border-gray-200">
//                                         <span>Your Current Points:</span>
//                                         <span className="text-green-600">{dashboardData?.balance}</span>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="p-8 flex justify-end space-x-4 border-t-4 border-gray-100 bg-gray-50 rounded-b-2xl">
//                                 <button
//                                     onClick={handleCloseDialog}
//                                     className="px-8 py-4 bg-gray-300 text-gray-800 rounded-xl hover:bg-gray-400 transition-colors duration-200 font-bold text-lg shadow-md transform hover:scale-105"
//                                 >
//                                     Not Now
//                                 </button>
//                                 <button
//                                     onClick={handleRedeemSubmit}
//                                     className={`px-8 py-4 rounded-xl font-extrabold text-lg text-white transition-all duration-300 ease-in-out shadow-lg transform hover:scale-105 flex items-center justify-center
//                                         ${redeeming || !addressLine1 || !city || !state || !postalCode || !country || !phoneNumber || !email ? 'bg-purple-300 cursor-not-allowed' : 'bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 active:from-purple-700 active:to-pink-700'}
//                                     `}
//                                     disabled={redeeming || !addressLine1 || !city || !state || !postalCode || !country || !phoneNumber || !email}
//                                 >
//                                     {redeeming ? (
//                                         <>
//                                             <div className="animate-spin rounded-full h-7 w-7 border-t-4 border-b-4 border-white mr-3"></div>
//                                             Sending...
//                                         </>
//                                     ) : (
//                                         'Yay! Get My Prize!'
//                                     )}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* Snackbar for notifications */}
//                 {snackbar.open && (
//                     <div
//                         className={`fixed bottom-8 right-8 p-6 rounded-2xl shadow-2xl text-white z-50 transition-all duration-500 transform
//                             ${snackbar.type === 'success' ? 'bg-green-500' : 'bg-red-500'}
//                             ${snackbar.open ? 'translate-y-0 opacity-100 animate-slide-in-right' : 'translate-y-full opacity-0'} flex items-center
//                         `}
//                     >
//                         {snackbar.type === 'success' ? <SparklesIcon className="h-7 w-7 mr-3 text-white" /> : <XMarkIcon className="h-7 w-7 mr-3 text-white" />}
//                         <span className="font-semibold text-lg">{snackbar.message}</span>
//                         <button onClick={handleCloseSnackbar} className="ml-5 text-white text-3xl font-bold leading-none">
//                             &times;
//                         </button>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };






import React, { useState, useEffect } from 'react';

import {

    Box,

    Typography,

    Grid,

    Card,

    CardContent,

    Button,

    styled,

    Avatar,

    LinearProgress,

    useTheme,

    Stack,

    Dialog,

    DialogTitle,

    DialogContent,

    DialogActions,

    TextField,

    CircularProgress,

    Snackbar,

} from '@mui/material';

import StarBorderIcon from '@mui/icons-material/StarBorder';

import LockIcon from '@mui/icons-material/Lock';

import TrendingUpIcon from '@mui/icons-material/TrendingUp';

import RedeemIcon from '@mui/icons-material/Redeem';

import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';

import axios from 'axios';

import { online } from '../Assets/index';

import baseUrl from '../config';



// Color definitions

const colors = {

    primary: '#42a5f5',

    secondary: '#ffc107',

    success: '#4caf50',

    greyLight: '#f5f5f5',

    greyMedium: '#e0e0e0',

    textPrimary: '#333',

    textSecondary: '#555',

    white: '#fff',

};



// Styled components

const StyledRewardCard = styled(Card)(({ theme, status }) => ({

    display: 'flex',

    flexDirection: 'column',

    height: '100%',

    padding: theme.spacing(2),

    backgroundColor: colors.white,

    border: `1px solid ${colors.greyMedium}`,

    borderRadius: 12,

    boxShadow: theme.shadows[2],

    transition: 'transform 0.2s ease-in-out',

    '&:hover': {

        transform: 'scale(1.03)',

    },

    ...(status === 'locked' && {

        opacity: 0.6,

        pointerEvents: 'none',

        '&:hover': {

            transform: 'none',

        },

    }),

}));



const EarnBadge = styled(Avatar)({

    width: 30,

    height: 30,

    fontSize: '0.8rem',

    marginRight: ({ theme }) => theme.spacing(1),

});



const StyledRedeemButton = styled(Button)(({ theme, rewardstatus }) => ({

    fontWeight: 'bold',

    padding: theme.spacing(0.7, 2),

    borderRadius: 8,

    fontSize: '0.8rem',

    textTransform: 'none',

    ...(rewardstatus !== 'redeemed' && {

        backgroundColor: colors.primary,

        color: colors.white,

        '&:hover': {

            backgroundColor: colors.primary,

            opacity: 0.9,

        },

    }),

    ...(rewardstatus === 'redeemed' && {

        color: colors.white,

        backgroundColor: colors.success,

        '&:hover': {

            backgroundColor: colors.success,

            opacity: 0.9,

        },

    }),

    ...(rewardstatus === 'locked' && {

        backgroundColor: theme.palette.grey[300],

        color: theme.palette.grey[600],

        pointerEvents: 'none',

    }),

}));



const Reward = () => {

    const theme = useTheme();

    const [dashboardData, setDashboardData] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);

    const [redeeming, setRedeeming] = useState(false);

    const [selectedProduct, setSelectedProduct] = useState(null);

    const [addressLine1, setAddressLine1] = useState('');

    const [addressLine2, setAddressLine2] = useState('');

    const [city, setCity] = useState('');

    const [state, setState] = useState('');

    const [postalCode, setPostalCode] = useState('');

    const [country, setCountry] = useState('India');

    const [phoneNumber, setPhoneNumber] = useState('');

    const [email, setEmail] = useState('');

    const [snackbar, setSnackbar] = useState({

        open: false,

        message: '',

        severity: 'success'

    });

    const token = localStorage.getItem('token');



    // Fetch dashboard data

    useEffect(() => {

        const fetchDashboardData = async () => {

            try {

                const response = await axios.get(baseUrl + 'api/students/wallet/getwallet', {

                    headers: {

                        Authorization: `Bearer ${token}`,

                    },

                });

                setDashboardData(response.data);

                setEmail(response.data.user?.email || '');

                setLoading(false);

            } catch (err) {

                setError(err.response?.data?.message || 'Failed to fetch dashboard data');

                setLoading(false);

                console.error(err);

            }

        };



        fetchDashboardData();

    }, [token, baseUrl]);



    // Handle product redemption

    const handleRedeemClick = (product) => {

        setSelectedProduct(product);

    };



    const handleCloseDialog = () => {

        setSelectedProduct(null);

        setAddressLine1('');

        setAddressLine2('');

        setCity('');

        setState('');

        setPostalCode('');

        setCountry('India');

        setPhoneNumber('');

    };



    const handleRedeemSubmit = async () => {

        setRedeeming(true);

        try {

            await axios.post(baseUrl + 'api/rewards/redeem', {

                productId: selectedProduct._id,

                studentsDetails: {

                    fullName: dashboardData?.userName,

                    addressLine1,

                    addressLine2,

                    city,

                    state,

                    postalCode,

                    country,

                    phoneNumber,

                    email

                }

            }, {

                headers: {

                    Authorization: `Bearer ${token}`,

                },

            });



            // Refresh dashboard data

            const response = await axios.get(baseUrl + 'api/students/wallet', {

                headers: {

                    Authorization: `Bearer ${token}`,

                },

            });

            setDashboardData(response.data);



            setSnackbar({

                open: true,

                message: 'Redemption request submitted for admin approval!',

                severity: 'success'

            });

            handleCloseDialog();

        } catch (err) {

            setSnackbar({

                open: true,

                message: err.response?.data?.message || 'Redemption failed',

                severity: 'error'

            });

        } finally {

            setRedeeming(false);

        }

    };



    const handleCloseSnackbar = () => {

        setSnackbar({ ...snackbar, open: false });

    };



    // Determine reward status based on points

    const getRewardStatus = (pointsRequired) => {

        if (!dashboardData) return 'locked';


        const userPoints = dashboardData.balance || 0;


        // Check if reward is already redeemed (you might need to add this logic based on your API)

        // For now, we'll just check points

        return userPoints >= pointsRequired ? 'available' : 'locked';

    };



    // Default rewards data

    const defaultRewards = [

        { _id: '1', name: 'Shoutout on Oratrics Page', pointsRequired: 150, image: online },

        { _id: '2', name: 'Custom Oratrics Badge', pointsRequired: 200, image: online },

        { _id: '3', name: 'Get 5 extra classes', pointsRequired: 250, image: online },

        { _id: '4', name: 'Get 5 Maths classes', pointsRequired: 350, image: online },

        { _id: '5', name: 'Amazon gift card ($50)', pointsRequired: 500, image: online },

        { _id: '6', name: 'Oratrics Goodie Bag', pointsRequired: 600, image: online },

        { _id: '7', name: 'RGB Desk Lamp', pointsRequired: 750, image: online },

        { _id: '8', name: 'Amazon Echo Dot', pointsRequired: 1000, image: online },

        { _id: '9', name: 'Amazon Kindle', pointsRequired: 1500, image: online },

        { _id: '10', name: 'Apple AirPods Pro', pointsRequired: 3000, image: online },

        { _id: '11', name: 'Sony PS5', pointsRequired: 4500, image: online },

        { _id: '12', name: 'Apple MacBook Air', pointsRequired: 10000, image: online },

    ];



    // Earn points actions

    const earnActions = [

        { text: 'Complete a course module', points: 10 },

        { text: 'Win a weekly speech challenge', points: 20 },

        { text: 'Share a speech on Social Media with #oratrics', points: 50 },

        { text: 'Get a friend to attend a free trial class', points: 100 },

    ];



    if (loading) {

        return (

            <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">

                <CircularProgress />

            </Box>

        );

    }



    if (error) {

        return (

            <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">

                <Typography color="error">{error}</Typography>

            </Box>

        );

    }



    return (

        <Box sx={{ padding: 1 }}>

            <Typography variant="h4" fontWeight="bold" color={colors.textPrimary} gutterBottom>

                Hey {dashboardData?.userName || 'User'},

            </Typography>

            <Typography variant="subtitle1" color={colors.textSecondary} sx={{ mb: 3, fontWeight: '500' }}>

                Welcome back! Explore new opportunities to earn and redeem rewards.

            </Typography>



            {/* Rewards Hub Section Header */}

            <Box sx={{

                backgroundColor: colors.secondary,

                padding: 2,

                marginBottom: 3,

                borderTopLeftRadius: 12,

                borderTopRightRadius: 12,

                display: 'flex',

                alignItems: 'center',

                color: colors.textPrimary,

            }}>

                <Typography variant="h6" fontWeight="bold">Your Rewards Hub</Typography>

                <EmojiEventsOutlinedIcon sx={{ marginLeft: 1.5, fontSize: '1.5rem' }} />

            </Box>



            <Grid container spacing={3}>

                {/* Current Points Card */}

                <Grid item xs={12} md={3}>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>

                        <Typography variant="h6" fontWeight="bold" color={colors.textPrimary}>

                            Current Points

                        </Typography>

                    </Box>

                    <StyledRewardCard sx={{ padding: 3, textAlign: 'center', alignItems: 'center' }}>

                        <Box sx={{ mb: 2 }}>

                            <StarBorderIcon sx={{ fontSize: '3rem', color: colors.secondary }} />

                        </Box>

                        <Typography color={colors.secondary} sx={{ fontWeight: 'bold', fontSize: '3rem', mb: 1 }}>

                            {dashboardData?.balance || 0}

                        </Typography>

                        <Typography variant="subtitle1" color={colors.textPrimary} sx={{ fontWeight: 'bold', mb: 2 }}>

                            Your Balance

                        </Typography>

                        <Typography variant="body2" color={colors.textSecondary} sx={{ lineHeight: 1.4, fontSize: '0.85rem', px: 2 }}>

                            Keep earning points to unlock more exciting rewards!

                        </Typography>

                    </StyledRewardCard>

                </Grid>



                {/* Earn Points Actions Card */}

                <Grid item xs={12} md={9}>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>

                        <TrendingUpIcon color="primary" sx={{ mr: 1.5, fontSize: '1.8rem' }} />

                        <Typography variant="h6" fontWeight="bold" color={colors.textPrimary}>

                            Earn Points

                        </Typography>

                    </Box>

                    <StyledRewardCard>

                        <CardContent>

                            <Stack spacing={2}>

                                {earnActions.map((item, index) => (

                                    <Box key={index} sx={{

                                        display: 'flex',

                                        alignItems: 'center',

                                        paddingX: 2,

                                        borderRadius: 10,

                                        backgroundColor: index % 2 !== 0 ? colors.greyLight : 'transparent',

                                        '&:hover': { backgroundColor: colors.greyMedium }

                                    }}>

                                        <EarnBadge badgeColor={colors.secondary}>{item.points}</EarnBadge>

                                        <Typography variant="body1" color={colors.textPrimary} sx={{ flexGrow: 1, fontSize: '0.9rem', marginLeft: 1 }}>

                                            {item.text}

                                        </Typography>

                                        <Button

                                            variant="outlined"

                                            size="small"

                                            sx={{

                                                color: colors.textPrimary,

                                                fontSize: '0.8rem',

                                                padding: '4px 14px',

                                                borderRadius: 8,

                                                fontWeight: 'bold',

                                                textTransform: 'none'

                                            }}

                                            startIcon={<TrendingUpIcon style={{ fontSize: '1rem' }} />}

                                        >

                                            Earn

                                        </Button>

                                    </Box>

                                ))}

                            </Stack>

                            <Button

                                variant="outlined"

                                fullWidth

                                sx={{

                                    marginTop: 2,

                                    borderRadius: 8,

                                    color: colors.textPrimary,

                                    fontWeight: 'bold',

                                    fontSize: '0.8rem',

                                    textTransform: 'none'

                                }}

                            >

                                View More Actions

                            </Button>

                        </CardContent>

                    </StyledRewardCard>

                </Grid>

            </Grid>



            {/* Available Rewards Section */}

            <Box sx={{ display: 'flex', alignItems: 'center', marginY: 3, marginTop: 10 }}>

                <RedeemIcon color="primary" sx={{ mr: 1.5, fontSize: '2rem' }} />

                <Typography variant="h5" fontWeight="bold" color={colors.textPrimary} gutterBottom>

                    Available Rewards

                </Typography>

            </Box>

            <Grid container spacing={3}>


                {defaultRewards.map((reward, index) => {

                    const status = getRewardStatus(reward.pointsRequired);

                    const progress = Math.min(100, ((dashboardData?.balance || 0) / reward.pointsRequired) * 100);


                    return (


                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>


                            <StyledRewardCard status={status === 'locked' ? 'locked' : undefined} sx={{ textAlign: 'left', height: '100%', padding: 0 }}>

                                <Box

                                    component="img"

                                    src={reward.image}

                                    alt={reward.name}

                                    sx={{

                                        width: '100%',

                                        maxWidth: '100%',

                                        height: 180,

                                        objectFit: 'cover',

                                        borderTopLeftRadius: 12,

                                        borderTopRightRadius: 12,

                                        marginBottom: 2,

                                    }}

                                />

                                <CardContent sx={{ padding: theme.spacing(1) }}>

                                    <Typography

                                        sx={{

                                            fontWeight: 'bold',

                                            border: '2px solid #111',

                                            borderRadius: '20px',

                                            padding: '5px 10px',

                                            display: 'inline-flex',

                                            alignItems: 'center',

                                        }}

                                    >

                                        {status === 'locked' ? (

                                            <>

                                                <LockIcon sx={{ marginRight: '8px' }} />

                                                Locked

                                            </>

                                        ) : (

                                            'Unlocked'

                                        )}

                                    </Typography>

                                    <Typography

                                        variant="subtitle1"

                                        fontWeight="bold"

                                        color={colors.textPrimary}

                                        gutterBottom

                                        sx={{

                                            fontSize: '1rem',

                                            lineHeight: 1.3,

                                            mt: 2

                                        }}

                                    >

                                        {reward.name}

                                    </Typography>

                                    <LinearProgress

                                        variant="determinate"

                                        value={progress}

                                        sx={{

                                            marginTop: 1,

                                            height: 8,

                                            borderRadius: 4,

                                            backgroundColor: theme.palette.grey[300],

                                            '& .MuiLinearProgress-bar': { backgroundColor: colors.secondary },

                                        }}

                                    />

                                    <Box sx={{

                                        marginTop: 1,

                                        marginBottom: 1,

                                        display: 'flex',

                                        justifyContent: 'space-between',

                                        alignItems: 'center'

                                    }}>

                                        <Typography sx={{ fontWeight: 'bold', color: colors.secondary, fontSize: '0.9rem' }}>

                                            {reward.pointsRequired} Points

                                        </Typography>

                                        {status !== 'locked' && (

                                            <Typography

                                                sx={{

                                                    fontWeight: 'bold',

                                                    fontSize: '0.8rem',

                                                    color: colors.secondary

                                                }}

                                            >

                                                Available

                                            </Typography>

                                        )}

                                    </Box>

                                    <StyledRedeemButton

                                        variant="contained"

                                        fullWidth

                                        rewardstatus={status}

                                        onClick={() => handleRedeemClick(reward)}

                                    >

                                        {status === 'locked' ? 'Locked' : 'Redeem Now'}

                                    </StyledRedeemButton>

                                </CardContent>

                            </StyledRewardCard>

                        </Grid>

                    );

                })}

            </Grid>



            {/* Redemption Dialog */}

            <Dialog open={!!selectedProduct} onClose={handleCloseDialog} maxWidth="md" fullWidth>

                <DialogTitle>Redeem {selectedProduct?.name}</DialogTitle>

                <DialogContent>

                    <Typography gutterBottom variant="h6" sx={{ mb: 2 }}>

                        Shipping Information

                    </Typography>

                    <Grid container spacing={2}>

                        <Grid item xs={12} sm={6}>

                            <TextField

                                fullWidth

                                label="Full Name"

                                value={dashboardData?.userName || ''}

                                margin="normal"

                                disabled

                            />

                        </Grid>

                        <Grid item xs={12} sm={6}>

                            <TextField

                                fullWidth

                                label="Email"

                                value={dashboardData?.email || ''}

                                onChange={(e) => setEmail(e.target.value)}

                                margin="normal"

                                required

                            />

                        </Grid>

                        <Grid item xs={12}>

                            <TextField

                                fullWidth

                                label="Address Line 1"

                                value={addressLine1}

                                onChange={(e) => setAddressLine1(e.target.value)}

                                margin="normal"

                                required

                            />

                        </Grid>

                        <Grid item xs={12}>

                            <TextField

                                fullWidth

                                label="Address Line 2 (Optional)"

                                value={addressLine2}

                                onChange={(e) => setAddressLine2(e.target.value)}

                                margin="normal"

                            />

                        </Grid>

                        <Grid item xs={12} sm={6}>

                            <TextField

                                fullWidth

                                label="City"

                                value={city}

                                onChange={(e) => setCity(e.target.value)}

                                margin="normal"

                                required

                            />

                        </Grid>

                        <Grid item xs={12} sm={6}>

                            <TextField

                                fullWidth

                                label="State/Province"

                                value={state}

                                onChange={(e) => setState(e.target.value)}

                                margin="normal"

                                required

                            />

                        </Grid>

                        <Grid item xs={12} sm={6}>

                            <TextField

                                fullWidth

                                label="Postal Code"

                                value={postalCode}

                                onChange={(e) => setPostalCode(e.target.value)}

                                margin="normal"

                                required

                            />

                        </Grid>

                        <Grid item xs={12} sm={6}>

                            <TextField

                                fullWidth

                                label="Country"

                                value={country}

                                onChange={(e) => setCountry(e.target.value)}

                                margin="normal"

                                required

                            />

                        </Grid>

                        <Grid item xs={12} sm={6}>

                            <TextField

                                fullWidth

                                label="Phone Number"

                                value={phoneNumber}

                                onChange={(e) => setPhoneNumber(e.target.value)}

                                margin="normal"

                                required

                            />

                        </Grid>

                    </Grid>

                    <Box sx={{ mt: 3, p: 2, backgroundColor: colors.greyLight, borderRadius: 2 }}>

                        <Typography variant="h6" sx={{ mb: 1 }}>Order Summary</Typography>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

                            <Typography>Product:</Typography>

                            <Typography fontWeight="bold">{selectedProduct?.name}</Typography>

                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

                            <Typography>Points Required:</Typography>

                            <Typography fontWeight="bold">{selectedProduct?.pointsRequired}</Typography>

                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

                            <Typography>Your Balance:</Typography>

                            <Typography fontWeight="bold">{dashboardData?.balance}</Typography>

                        </Box>

                    </Box>

                </DialogContent>

                <DialogActions>

                    <Button onClick={handleCloseDialog}>Cancel</Button>

                    <Button

                        onClick={handleRedeemSubmit}

                        color="primary"

                        variant="contained"

                        disabled={redeeming || !addressLine1 || !city || !state || !postalCode || !country || !phoneNumber || !email}

                    >

                        {redeeming ? <CircularProgress size={24} /> : 'Submit Redemption Request'}

                    </Button>

                </DialogActions>

            </Dialog>



            {/* Snackbar for notifications */}

            <Snackbar

                open={snackbar.open}

                autoHideDuration={6000}

                onClose={handleCloseSnackbar}

                message={snackbar.message}

                severity={snackbar.severity}

            />

        </Box>

    );

};



export default Reward;